<template>
	<router-link :to="seccion.Href" :class="seccion.Css">
		<img  v-if="seccion.ImgUrl != '#'" :src="seccion.ImgUrl"> 
		{{ seccion.Nombre }}
	</router-link>
</template>
<script>
	export default {
		props: {
			seccion: Object
		}
	};
</script>